// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1d6d68f7","732":"540d5905","977":"a8d425dc"}[chunkId] + ".chunk.js";
};